
import React from "react";
import { TableCell, TableRow } from "@/components/ui/table";
import { StrategyWithDetails } from "@/types/strategy-types";
import StrategyActions from "./StrategyActions";

interface TableBodyProps {
  strategies: StrategyWithDetails[];
  onToggleStatus: (strategyId: string, currentStatus: boolean) => Promise<void>;
  onToggleActive: (strategyId: string, currentActive: boolean) => Promise<void>;
  onApproveStrategy: (strategyId: string, approved: boolean) => Promise<void>;
  onEdit: (strategy: StrategyWithDetails) => void;
  onDelete: (strategyId: string) => void;
  onPreview: (strategy: StrategyWithDetails) => void;
  userRole?: string | null;
}

const TableBody = ({
  strategies,
  onToggleStatus,
  onToggleActive,
  onApproveStrategy,
  onEdit,
  onDelete,
  onPreview,
  userRole
}: TableBodyProps) => {
  if (strategies.length === 0) {
    return (
      <TableRow>
        <TableCell colSpan={9} className="text-center py-8 text-gray-500">
          No strategies found
        </TableCell>
      </TableRow>
    );
  }

  return (
    <>
      {strategies.map((strategy) => (
        <TableRow key={strategy.id}>
          <TableCell className="font-medium">{strategy.name}</TableCell>
          <TableCell>{strategy.exchange}</TableCell>
          <TableCell className="text-right">{strategy.min_investment}</TableCell>
          <TableCell>{strategy.provider_name || 'N/A'}</TableCell>
          <TableCell>
            <div className="flex items-center">
              <div className={`h-2.5 w-2.5 rounded-full mr-2 ${
                strategy.plan === 'premium' || strategy.plan === 'pro' ? 'bg-green-500' : 'bg-gray-400'
              }`}></div>
              {strategy.plan === 'premium' || strategy.plan === 'pro' ? 'Premium' : 'Free'}
            </div>
          </TableCell>
          <TableCell>
            <div className="flex items-center">
              <div className={`h-2.5 w-2.5 rounded-full mr-2 ${strategy.active ? 'bg-green-500' : 'bg-gray-400'}`}></div>
              {strategy.active ? 'Active' : 'Inactive'}
            </div>
          </TableCell>
          <TableCell>
            <div className="flex items-center">
              <div className={`h-2.5 w-2.5 rounded-full mr-2 ${strategy.approved ? 'bg-green-500' : 'bg-yellow-500'}`}></div>
              {strategy.approved ? 'Approved' : 'Pending'}
            </div>
          </TableCell>
          <TableCell>{new Date(strategy.created_at || '').toLocaleDateString()}</TableCell>
          <TableCell>
            <StrategyActions
              strategy={strategy}
              onToggleStatus={onToggleStatus}
              onToggleActive={onToggleActive}
              onApproveStrategy={onApproveStrategy}
              onEdit={onEdit}
              onDelete={onDelete}
              onPreview={onPreview}
              userRole={userRole}
            />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default TableBody;
